// App styles
export const appStyles = {
    text12: {
        fontWeight: 'palette.regular',
        fontSize: '0.75rem',
        lineHeight: '1rem',
        letterSpacing: '0.4px',
    },
    text14: {
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        alignItems: 'center',
        letterSpacing: '0.00625rem',
    },
    text16: {
        fontWeight: '400',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        letterSpacing: '0.5px',
    },
    text22: {
        fontWeight: '400',
        fontSize: '1.375rem',
        lineHeight: '1.75rem',
        letterSpacing: '0.15px',
        color: '#000000',
    },
    text24: {
        fontWeight: '500',
        fontSize: '1.5rem',
        lineHeight: '2rem',
        letterSpacing: '0.15px',
        color: '#000000',
    },
    text28: {
        fontWeight: '400',
        fontSize: '1.75rem',
        lineHeight: '2.25rem',
        color: '#000000',
    },
    tableCell: {
        fontWeight: '400',
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        letterSpacing: '0.25px',
        color: '#000000',
    },
    page: {
        background: 'white.main',
        boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
        borderRadius: '1rem',
        height: 'calc(100%)',
        boxSizing: 'border-box',
        overflow: 'hidden',
        padding: {
            sm: '1.5rem',
            xs: '0.5rem',
        },
    },
    boxShadow: {
        boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
    },
    fontFamily: {
        fontFamily: 'DM Sans',
    },
};
